module.exports = __webpack_public_path__ + "static/img/avatar.d3f2c0ee.png";